import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    marginLeft: theme.spacing(1),
  },
  topBottomSpacing: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  cancelIcon: {
    color: theme.colors.red,
  },
}));
